import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import logo from "../../assets/images/genelogo.jpeg";
import { ChevronDown } from "lucide-react";
import { cardsData } from "../../data/data";

import "./Navbar.css";

const Navbar = () => {
  const [active, setActive] = useState("home");
  const [isOpen, setIsOpen] = useState(false);
  const [openSubItem, setOpenSubItem] = useState(null);

  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath === "/") {
      setActive("home");
    } else if (currentPath === "/about") {
      setActive("about");
    } else if (currentPath.includes("#")) {
      setActive("#");
    } else if (currentPath.includes("key-conditions")) {
      setActive("key-conditions");
    } else if (currentPath.includes("gallery")) {
      setActive("gallery");
    } else if (currentPath.includes("contact")) {
      setActive("contact");
    }
  }, [location]);

  const toggleSubItems = (itemName) => {
    setOpenSubItem((prev) => (prev === itemName ? null : itemName));
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light custom-navbar">
      <div className="container-fluid">
        {/* Logo */}
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <div className="logo-container">
            <img
              src={logo}
              alt="Logo"
              width="80"
              height="80"
              className="logo-image"
            />
          </div>
          <span className="brand-name">GENE THERAPTICS</span>
        </Link>

        {/* Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Links */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link
                to="/"
                className={`nav-link ${active === "home" ? "active-link" : ""}`}
              >
                HOME
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/about"
                className={`nav-link ${active === "about" ? "active-link" : ""
                  }`}
              >
                ABOUT
              </Link>
            </li>

            {/* Product Groups Dropdown */}
            <div
              className="nav-item dropdown"
              onMouseEnter={() => setIsOpen(true)}
              onMouseLeave={() => setIsOpen(false)}
            >
              <li className="nav-item">
                <Link
                  to="#"
                  className={`nav-link dropdown-toggle ${active === "product-groups" ? "active-link" : ""
                    }`}
                >
                  PRODUCTS
                </Link>
              </li>

              {isOpen && cardsData?.length > 0 && (
                <div className="dropdown-menu mega-menu show">
                  <div className="mega-menu-content">
                    <div className="row g-4">
                      {cardsData.map((group, ind) => (
                        <div key={group.id} className="col-md-4">
                          <div className="category-group">
                            <Link
                              to={`/category/${group.id}/${ind + 101}`}
                              className="category-title"
                            >
                              {group.title}
                            </Link>
                            <ul className="category-list">
                              {group.subitems.map((item, i) => (
                                <li key={item.id} className="category-item">
                                  <div className="subcategory-header">
                                    <Link
                                      to={`/category/${group.id}/${i + 101}`}
                                      className="subcategory-title"
                                    >
                                      {item.title}
                                    </Link>
                                    <ChevronDown
                                      size={16}
                                      className={`subcategory-icon ${openSubItem === item.title ? "rotate" : ""
                                        }`}
                                      onClick={() => toggleSubItems(item.title)}
                                    />
                                  </div>

                                  {openSubItem === item.title && item.items?.length > 0 && (
                                    <ul className="subcategory-items">
                                      {item.items.map((sub) => (
                                        <li key={sub.id} className="subcategory-subitem">
                                          <Link
                                            to={`/subcategory/${item.id}/${sub.id}`}
                                            className="subcategory-link"
                                          >
                                            {sub.name}
                                          </Link>
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>


            <li className="nav-item">
              <Link
                to="#"
                className={`nav-link ${active === "key-conditions" ? "active-link" : ""
                  }`}
              >
                KEY CONDITIONS
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/gallery"
                className={`nav-link ${active === "gallery" ? "active-link" : ""
                  }`}
              >
                GALLERY
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/contact"
                className={`nav-link ${active === "contact" ? "active-link" : ""
                  }`}
              >
                CONTACT US
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;